import {combineReducers} from 'redux';
import adStore from './adStore';
import affiliateStore from './affiliateStore';
import errorStore from './errorStore';
import footerStore from './footerStore';
import funeralHomeStore from './funeralHomeStore';
import nearbyFuneralHomesStore from './nearbyFuneralHomesStore';
import headerStore from './headerStore';
import mobileDetailsStore from './mobileDetailsStore';
import obituaryStore from './obituaryStore';
import personStore from './personStore';
import planningStore from './planningStore';
import searchFuneralHomesStore from './searchFuneralHomesStore';
import tabIndexStore from './tabStore';
import upcomingServicesStore from './upcomingServicesStore';

export default combineReducers({
  adStore,
  affiliateStore,
  errorStore,
  footerStore,
  funeralHomeStore,
  nearbyFuneralHomesStore,
  headerStore,
  mobileDetailsStore,
  obituaryStore,
  personStore,
  planningStore,
  searchFuneralHomesStore,
  tabIndexStore,
  upcomingServicesStore,
});



// WEBPACK FOOTER //
// ./src/reactModules/redux/reducers/combinedReducers.js